import React, { createContext, useContext, useEffect, useState } from 'react'
import { AppContext } from 'context/appContext'
import { asideInfoByStep } from '../constants'
import { getAsideInfo } from '../helpers'
import { useTranslation } from 'react-i18next'
import { WIZARD_STAGES_ID } from 'utils/constants'

export interface IOnboardingAsideContext {
  asideInfo: any
}

const OnboardingAsideContext = createContext({} as IOnboardingAsideContext)

const useOnbaordingAsideContext = (): IOnboardingAsideContext => {
  const { t } = useTranslation()
  const { wizardData } = useContext(AppContext)
  const [asideInfo, setAsideInfo] = useState(asideInfoByStep(t)[WIZARD_STAGES_ID.confirmation])

  useEffect(() => {
    setAsideInfo(getAsideInfo(t, wizardData.stageOnPlate.name))
  }, [wizardData.stageOnPlate])

  return {
    asideInfo
  }
}

const OnboardingAsideContextProvider = ({ children }) => {
  const values = useOnbaordingAsideContext()
  return <OnboardingAsideContext.Provider value={values}>{children}</OnboardingAsideContext.Provider>
}

export { OnboardingAsideContext, OnboardingAsideContextProvider }
